import { Routes } from '@angular/router';
import { ReservationComponent } from './pages/reservation/reservation.component';
import { TermsComponent } from './shared/components/terms/terms.component';
import { PoliciesComponent } from './shared/components/policies/policies.component';
import { ConfirmReservationComponent } from './pages/confirm-reservation/confirm-reservation.component';
import { PortalComponent } from './pages/portal/portal.component';
import { PortalRedirectComponent } from './pages/portal-redirect/portal-redirect.component';
import { AuthFallbackComponent } from './pages/auth-fallback/auth-fallback';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'reservation',
    pathMatch: 'full',
  },
  {
    path: 'reservation',
    component: ReservationComponent,
  },
  {
    path: 'reservation/:id',
    component: ReservationComponent,
  },
  {
    path: 'terms',
    component: TermsComponent,
  },
  {
    path: 'policies',
    component: PoliciesComponent,
  },
  {
    path: 'confirm',
    component: ConfirmReservationComponent,
  },
  {
    path: 'portal/:branchId',
    component: PortalComponent,
  },
  {
    path: 'acompanhe/:code',
    component: PortalRedirectComponent,
  },
  {
    path: 'auth-fallback',
    component: AuthFallbackComponent,
  },
  {
    path: '**',
    redirectTo: 'reservation',
    pathMatch: 'full',
  },
];
